import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import EditableTimeInput from './EditableTimeInput';
const decimalHoursToMinutes = (hours) => {
    if (hours == null || isNaN(hours))
        return 0;
    return Math.round(Math.abs(hours) * 60) * (hours < 0 ? -1 : 1);
};
const minutesToDecimalHours = (minutes) => {
    if (minutes == null)
        return null;
    return minutes / 60;
};
const EditableDecimalHoursInput = ({ onChange, value, readOnly = false, min = 0, max = 1439, displayClassName = '', inputClassName = '', }) => {
    const minuteValue = decimalHoursToMinutes(value);
    const displayValue = (value !== null && value !== void 0 ? value : 0).toTime();
    return (_jsx(EditableTimeInput, { onChange: (minutes) => onChange(minutesToDecimalHours(minutes)), value: minuteValue, displayValue: displayValue, readOnly: readOnly, min: min, max: max, displayClassName: displayClassName, inputClassName: inputClassName }));
};
export default EditableDecimalHoursInput;
